module.exports = __webpack_public_path__ + "files/510aa22c47d55c08305cb680f18eb1be.png";